import { apiCall } from './gqlClient';

const ATHLETEPLANMUSCLEVOLUME_QUERY = `
  query athletePlanMuscleVolume($planId: String!) {
    athletePlanMuscleVolume(planId: $planId)
    {
      planId
      ...fragments
    }
  }`;

export const athletePlanMuscleVolumeApiCall = async ({planId}, fragments = null) => apiCall({ query: ATHLETEPLANMUSCLEVOLUME_QUERY, variables: {planId}, fragments });
